<template>
    <div>
        <div :class="{
        'marketo-root': isAssetRoot(this),
        'marketo-folder': isFolder(this),
        'marketo-workspace': isAssetWorkspace(this),
        'main': false,
        'active': active,
        'marketo-empty': isAssetEmptyFolder(this),
        }">
            <a href="javascript:" @click="childClick" :class="{
            'marketo-item': true,
            'main': false,
            'marketo-root': isAssetRoot(this),
            'marketo-folder': isFolder(this),
            'marketo-empty': isAssetEmptyFolder(this),
            'marketo-workspace': isAssetWorkspace(this),
            'marketo-empty-workspace': isEmptyWorkspace(this),

            }">{{ name }}</a>

            <div v-for="child in children" v-show="active">

                <marketo-child :tree="child.children" :workspace="child.workspace" :parent_key="child.parent_key" :id_key="child.key" :parent_active="active"
                               :folderType="child.folderType" :idType="child.idType" :parent_id="folder_id" :parent_path="path"
                               :folder_id="child.id" :type="child.type" :name="child.name"
                               v-if="child.type == 'folder'"></marketo-child>

                <div :class="{
                'marketo-email' : isAssetEmail(child),
                'marketo-email-template' : isAssetEmailTemplate(child),
                'marketo-landing-page' : isAssetLandingPage(child),
                'marketo-landing-page-template' : isAssetLandingPageTemplate(child),
                'marketo-snippet' : isAssetSnippet(child),

                                'marketo-item': true,
                                'main': false,
                                'marketo-file': true,
                                'marketo-selected': isAssetSelected(child),
                                'marketo-found': isAssetFound(child)
                            }" v-if="child.type !== 'folder'" @click="selectFile(child)">
                    {{ child.name }}
                </div>

                <div class="marketo-item" v-show="children.length === 0">
                    <em>(empty folder)</em>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import {EventBus} from "../../event-bus";

    import AssetMixin from '../../assetMixins.js'

    export default {

        mixins: [AssetMixin],

        name: 'marketo-child',

        props: {
            tree: Array,
            folder_id: Number,
            idType: String,
            parent_id: Number,
            main: Boolean,
            parent_active: Boolean,
            parent_path: String,
            name: String,
            folderType: String,
            parent_key: String,
            id_key: String,
            type: String,
            workspace: String,
        },

        data() {
            return {
                active: false,
                loading: true,
                children: [],
                query: null,
                selected: [],
                found_items: [],
            };
        },

        methods: {

            selectFile(file) {

                if (typeof file === false) return false;

                if (this.isAssetSelected(file)) {
                    EventBus.$emit('filepicker_file_deselect', {file: file});
                    return;
                }

                file.tree = this.getTree();
                file.folder = this.name;

                EventBus.$emit('filepicker_file_select', {file: file});
            },

            getTree() {
                return this.tree.concat([this.folder_id]);
            },

            loadChildren() {
                this.children = this.tree;
            },

            openTree() {
                if(this.parent_active)
                    return;

                EventBus.$emit('open_tree', {tree: this.getTree()});
            },

            /*
            isAssetEmail (item) {
              return (this.isAsset(item) && item.module === 'email');
            },

            isAssetEmailTemplate (item) {
              return (this.isAsset(item) && item.module === 'emailTemplate');
            },

            isAssetLandingPage (item) {
              return (this.isAsset(item) && item.module === 'landingPage');
            },

            isAssetLandingPageTemplate (item) {
              return (this.isAsset(item) && item.module === 'landingPageTemplate');
            },

            isAssetSnippet (item) {
              return (this.isAsset(item) && item.module === 'snippet');
            },

            isAssetRoot (item) {
              return (item.folderType === 'Zone' && item.parent_key == null);
            },

            isAssetWorkspace (item) {
              return (item.folderType === 'Zone' && item.parent_key != null);
            },

            isAsset (item) {
              return item.type !== 'folder';
                  },

            */

            isAssetSelected (item) {
                var found = false;

                this.selected.forEach(asset => {
                    if(asset.id === item.id && item.module === asset.module)
                        found = true;
                });

                return found;
            },

            isAssetFound(item)
            {
                var found = false;

                this.found_items.forEach(asset => {
                    if(asset.id === item.id && item.module === asset.module)
                        found = true;
                });

                return found;
            },



            isEmptyWorkspace (item) {
                if (!this.isAssetWorkspace(item)) return false;

                return (item.children.length === 0);
            },

            isAssetEmptyFolder (item) {
                if (this.isAssetWorkspace(item)) return false;

                return (item.children.length === 0)
            },

            isFolder (item) {
                if (!this.isAssetWorkspace(item) && !this.isAssetRoot(item)) {
                    return item.type === 'folder';
                }
            },

            childClick (event) {
                this.active = !this.active;

                if (this.isAssetRoot(this)) {

                    return false;
                }

                if (this.isAssetWorkspace(this)) {

                    if (this.children.length === 0) {
                        EventBus.$emit('get_workspace_tree', {
                            key: this.id_key,
                            name: this.name,
                            workspace: this.workspace
                        });
                    }

                    return false;
                }
                else if (this.isAsset(this)) {

                    this.selectFile(this);
                }
            },

            searchFor(query) {
                if(query === '' || query === null)
                    return;

                query = query.toLowerCase();

                var found = false;

                var vm = this;

                this.children.forEach(item => {
                    var name = item.name.toLowerCase();

                    if(name.toLowerCase().search(query) !== -1) {
                        vm.openTree();
                        this.found_items.push(item);

                    }
                });

                EventBus.$emit('search_results_feedback', {
                    matched: this.found_items.length,
                    not_matched: this.children.length - this.found_items.length
                });
            }

        },

        computed: {

            path() {
                return this.parent_path + '/' + this.name;
            }

        },

        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.loadChildren();
                }, 1000);
            });

            EventBus.$on('open_tree', data => {
                if(data.tree.indexOf(this.folder_id) !== -1 && ! this.active)
                {
                    this.active = true;
                }
            });

            EventBus.$on('search', data => {
                this.found_items = [];
                this.query = data.query;

                this.searchFor(data.query);
            });

            EventBus.$on('expand_all', data => {
                this.active = true;
            });

            EventBus.$on('collapse_all', data => {
                this.active = false;
            });

            EventBus.$on('update_selected_assets', data => {
                this.selected = data.files;
            });
        }

    };
</script>
